module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_preocupacion.57cbd739.jpg";